import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  InputGroupText,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import CustomerServices from "../../../services/OrderingServices/CustomerServices";
import DeleteModal from "../../../Components/Common/DeleteModal";
import UnitForm from "../component/UnitForm";
import UnitService from "../../../services/OrderingServices/UnitService";
import useIsSmallScreen from "../../Payment Type/Component/small screen/SmallScreen";

import useTableSearch from "../../../hooks/useTableSearch";
import TableSearch from "../../../Components/Common/TableSearch";
const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const Unit = () => {
  const [unitList, setUnitList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [selectedUnit, setSelectedCustomer] = useState();
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const isSmallScreen = useIsSmallScreen();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => `${row.name}`,
      cell: (row) => row.name,
      sortable: true,
    },

    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
    },
    {
      name: "Ratio",
      selector: (row) => row.ratio,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => {
              setAddModal(true);
              setSelectedCustomer(row);
            }}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </div>
      ),
      center: true,
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  const { searchTerm, setSearchTerm, filteredData } = useTableSearch(unitList, [
    "name",
    "description",
    "ratio",
  ]);
  const fetchUnit = async () => {
    try {
      setLoading(true);
      const response = await UnitService.getList();

      setUnitList(response);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchUnit();
  }, []);
  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  // const filteredData = unitList.filter((pkg) => {
  //   // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);

  //   // Combine name, surname, email, and phone number into a single search context, handling undefined fields
  //   const searchContext = `${pkg?.name || ""}`.toLowerCase();

  //   // Check if the filterText is included in any of the search context
  //   const matchesFilter = searchContext.includes(filterText.toLowerCase());
  //   return matchesFilter;
  // });
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedCustomer(item);
    toggleDeleteModal();
  };
  const handleDelete = async () => {
    if (selectedUnit) {
      try {
        await UnitService.delete(selectedUnit);
        setUnitList((prevList) =>
          prevList.filter((pkg) => pkg.id !== selectedUnit)
        );
        toast.success("Selected unit deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedCustomer(null);
      }
    }
  };
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Unit" pageTitle="System Setup" />

        <div
          className="p-3 p-lg-4 mt-1"
          style={{
            background: "#fff",
            borderRadius: "0.5rem",
            boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
            border: "1px solid #eee",
          }}
        >
          {/* Filter Button */}
          <Row className="justify-content-between align-content-center align-items-center ">
            <Col md={6} className="align-items-center">
              <h5 className="mb-1 fw-bold text-dark ">Units List</h5>
            </Col>
            <Col md={6} className="mb-3">
              <div className="d-flex justify-content-end align-content-center align-items-center gap-3">
                <div className="d-flex align-items-center justify-content-end">
                  <TableSearch
                    value={searchTerm}
                    onChange={setSearchTerm}
                    placeholder="Search by all.."
                  />
                </div>
                <Button
                  color="success"
                  onClick={() => setAddModal(true)}
                  className="d-flex align-items-center gap-2"
                  style={{ borderRadius: "8px" }}
                >
                  <i className="bx bx-plus"></i> Add
                </Button>
              </div>
            </Col>
            {/* </div> */}
          </Row>

          {isSmallScreen ? (
            loading ? (
              <div className="d-flex justify-content-center my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                />
              </div>
            ) : (
              <>
                {filteredData?.map((item, index) => (
                  <Card
                    key={item?.id || index}
                    className="mb-3 shadow-sm d-block d-lg-none"
                  >
                    <CardBody>
                      <Row>
                        <Col xs={10}>
                          <h6 className="mb-2">Name: {item?.name}</h6>
                          <h6 className="mb-2 text-muted">
                            Description: {item.description || "N/A"}
                          </h6>
                          <h6 className="mb-2 text-muted">
                            Ratio: {item.ratio}
                          </h6>
                        </Col>
                        <Col xs={2}>
                          <div>
                            <Dropdown
                              isOpen={item.dropdownOpen || false}
                              toggle={(e) => {
                                e.stopPropagation();
                                setUnitList((prev) =>
                                  prev.map((unit) =>
                                    unit.id === item.id
                                      ? {
                                          ...unit,
                                          dropdownOpen: !unit.dropdownOpen,
                                        }
                                      : { ...unit, dropdownOpen: false }
                                  )
                                );
                              }}
                              direction="down"
                            >
                              <DropdownToggle
                                color="primary"
                                outline
                                className="btn-sm shadow-sm rounded-circle"
                              >
                                <i className="ri-more-2-fill"></i>
                              </DropdownToggle>
                              <DropdownMenu end>
                                <DropdownItem
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setAddModal(true);
                                    setSelectedCustomer(item);
                                  }}
                                >
                                  <i className="ri-edit-line text-warning me-2"></i>{" "}
                                  Edit
                                </DropdownItem>
                                <DropdownItem
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteClick(item.id);
                                  }}
                                >
                                  <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                ))}
              </>
            )
          ) : (
            <CustomDataTable
              responsive
              striped
              pagination
              fixedHeader
              persistTableHead
              progressPending={loading}
              customStyles={customStyles}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              paginationDefaultPage={currentPage}
              paginationPerPage={perPage}
              progressComponent={
                <div className="my-3 text-center">
                  <Triangle
                    visible={true}
                    height="80"
                    width="80"
                    color="#5B71B9"
                  />
                  <h5 className="mt-1">Loading...</h5>
                </div>
              }
              columns={columns}
              data={filteredData}
              noDataComponent={
                <div className="text-center my-5 w-100">
                  <i className="ri-emotion-unhappy-line display-4 text-secondary" />
                  <h5 className="fw-semibold text-secondary">
                    No data Available
                  </h5>
                  <p className="text-muted mb-0">No recipes found.</p>
                </div>
              }
            />
          )}
        </div>
      </div>{" "}
      <UnitForm
        modal={addModal}
        toggleModal={() => {
          setAddModal(false);
          setSelectedCustomer(null); // Clear editing state when closing
        }}
        setUnitList={setUnitList}
        unitList={unitList}
        selectedUnit={selectedUnit}
        fetchUnit={fetchUnit}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedUnit} // Pass the selected item
      />
    </Container>
  );
};

export default Unit;
